const parent = document.querySelector('.desc-section__parent');
const circles = document.querySelectorAll('.desc-section__circle');

circles.forEach(circle => {
  circle.addEventListener('click', () => {
    const isActive = circle.classList.contains('active');

    // Remove all active classes
    circles.forEach(c => c.classList.remove('active'));
    parent.classList.remove('active');

    // Toggle selected one if it wasn't already active
    if (!isActive) {
      circle.classList.add('active');
      parent.classList.add('active');
    }
  });
});
